var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10547 7.63184V13.5266C2.10547 13.9174 2.26073 14.2923 2.5371 14.5686C2.81347 14.845 3.18831 15.0003 3.57915 15.0003H12.4213C12.8121 15.0003 13.1869 14.845 13.4633 14.5686C13.7397 14.2923 13.8949 13.9174 13.8949 13.5266V7.63184",
    stroke: "#BAC1DA",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00015 3.57895C8.00015 2.89497 7.72844 2.239 7.2448 1.75536C6.76115 1.27171 6.10519 1 5.42121 1C4.93265 1 4.4641 1.19408 4.11864 1.53954C3.77318 1.885 3.5791 2.35355 3.5791 2.84211C3.5791 3.33066 3.77318 3.79921 4.11864 4.14467C4.4641 4.49013 4.93265 4.68421 5.42121 4.68421H8.00015M8.00015 3.57895V4.68421M8.00015 3.57895C8.00015 2.89497 8.27186 2.239 8.75551 1.75536C9.23916 1.27171 9.89512 1 10.5791 1C11.0677 1 11.5362 1.19408 11.8817 1.53954C12.2271 1.885 12.4212 2.35355 12.4212 2.84211C12.4212 3.08401 12.3736 3.32355 12.281 3.54705C12.1884 3.77054 12.0527 3.97362 11.8817 4.14467C11.7106 4.31573 11.5075 4.45141 11.284 4.54399C11.0606 4.63656 10.821 4.68421 10.5791 4.68421H8.00015",
    stroke: "#BAC1DA",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99974 7.63145V14.9999M1.36816 4.68408H14.6313V7.63145H1.36816V4.68408Z",
    stroke: "#BAC1DA",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.377c4f9b2ea0e4ea55169da51fda498e.svg";
export { ForwardRef as ReactComponent };